import styled from 'styled-components';
import LOGO2 from '../assets/logo2.png'
import APP from '../assets/app.png'

function HomePage() {

  return (
    <Container>

        <img className='logo' src={LOGO2}/>

          <div className="title">
            Não perca tempo, baixe o app e faça seu primeiro pedido agora mesmo!
          </div>

           <div className="subtitle">
            
          </div>  

          <div className='download'>

            <div className='picture'>
              <img className="app" src={APP}/>
            </div>
            <div className='buttons'>

           
          <a href="https://play.google.com/store/apps/details?id=br.com.entregakii" target="_blank"><button >
              <div className='subtitle'>Disponível na</div>
            
              <div className='info'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.9753 3.01891L15.9351 1.28732C15.9475 1.26511 15.9553 1.24068 15.9582 1.21545C15.961 1.19021 15.9589 1.16465 15.9519 1.14024C15.9449 1.11582 15.9332 1.09302 15.9174 1.07314C15.9016 1.05326 15.882 1.03669 15.8598 1.02438C15.8149 0.999506 15.762 0.993475 15.7127 1.00761C15.6634 1.02175 15.6217 1.0549 15.5968 1.09976L14.6264 2.85054C13.7984 2.48755 12.9041 2.30014 12 2.30014C11.0959 2.30014 10.2016 2.48755 9.37362 2.85054L8.40314 1.09976C8.37827 1.0549 8.33659 1.02175 8.28728 1.00761C8.23797 0.993475 8.18506 0.999506 8.14019 1.02438C8.09533 1.04925 8.06218 1.09093 8.04804 1.14024C8.03391 1.18955 8.03994 1.24246 8.06481 1.28732L9.02466 3.01892C8.11099 3.46929 7.339 4.16259 6.79337 5.02277C6.24774 5.88296 5.94955 6.87679 5.9315 7.89527H18.0685C18.0504 6.87679 17.7523 5.88295 17.2066 5.02277C16.661 4.16258 15.889 3.46928 14.9753 3.01891ZM9.19909 5.67451C9.09885 5.67451 9.00087 5.64479 8.91753 5.5891C8.83418 5.53341 8.76923 5.45426 8.73087 5.36166C8.69251 5.26905 8.68247 5.16715 8.70203 5.06884C8.72158 4.97053 8.76985 4.88023 8.84073 4.80935C8.9116 4.73847 9.00191 4.69021 9.10022 4.67065C9.19853 4.6511 9.30043 4.66113 9.39303 4.69949C9.48564 4.73785 9.56479 4.80281 9.62048 4.88615C9.67617 4.96949 9.70589 5.06748 9.70589 5.16771C9.70574 5.30208 9.6523 5.4309 9.55728 5.52591C9.46227 5.62092 9.33345 5.67436 9.19909 5.67451ZM14.8009 5.67451C14.7006 5.67451 14.6026 5.64479 14.5193 5.5891C14.436 5.53341 14.371 5.45426 14.3326 5.36166C14.2943 5.26905 14.2843 5.16715 14.3038 5.06884C14.3234 4.97053 14.3716 4.88023 14.4425 4.80935C14.5134 4.73847 14.6037 4.69021 14.702 4.67065C14.8003 4.6511 14.9022 4.66113 14.9948 4.69949C15.0874 4.73785 15.1666 4.80281 15.2223 4.88615C15.2779 4.96949 15.3077 5.06748 15.3077 5.16771C15.3075 5.30208 15.2541 5.4309 15.1591 5.52591C15.0641 5.62092 14.9352 5.67436 14.8009 5.67451ZM5.93141 17.1715C5.93141 17.5606 6.08598 17.9338 6.36112 18.2089C6.63626 18.4841 7.00943 18.6386 7.39854 18.6386H8.37214V21.6396C8.37165 21.8186 8.40649 21.9959 8.47464 22.1614C8.54279 22.3268 8.64292 22.4772 8.7693 22.604C8.89568 22.7307 9.04582 22.8312 9.21112 22.8998C9.37642 22.9684 9.55363 23.0037 9.73259 23.0037C9.91156 23.0037 10.0888 22.9684 10.2541 22.8998C10.4194 22.8312 10.5695 22.7307 10.6959 22.604C10.8223 22.4772 10.9224 22.3268 10.9906 22.1614C11.0587 21.9959 11.0935 21.8186 11.093 21.6396V18.6386H12.9069V21.6396C12.9064 21.8186 12.9413 21.9959 13.0094 22.1614C13.0776 22.3268 13.1777 22.4772 13.3041 22.604C13.4304 22.7307 13.5806 22.8312 13.7459 22.8998C13.9112 22.9684 14.0884 23.0037 14.2674 23.0037C14.4463 23.0037 14.6235 22.9684 14.7888 22.8998C14.9541 22.8312 15.1043 22.7307 15.2307 22.604C15.357 22.4772 15.4572 22.3268 15.5253 22.1614C15.5935 21.9959 15.6283 21.8186 15.6278 21.6396V18.6386H16.6015C16.9906 18.6386 17.3637 18.4841 17.6389 18.2089C17.914 17.9338 18.0686 17.5606 18.0686 17.1715V8.37537H5.93141V17.1715ZM4.06413 8.14196C3.70344 8.14237 3.35764 8.28584 3.1026 8.54089C2.84755 8.79593 2.70409 9.14173 2.70368 9.50242V15.1709C2.70319 15.3499 2.73803 15.5272 2.80618 15.6926C2.87433 15.8581 2.97446 16.0085 3.10084 16.1353C3.22722 16.262 3.37736 16.3625 3.54266 16.4311C3.70796 16.4997 3.88517 16.535 4.06413 16.535C4.2431 16.535 4.42031 16.4997 4.58561 16.4311C4.75091 16.3625 4.90105 16.262 5.02743 16.1353C5.15381 16.0085 5.25394 15.8581 5.32209 15.6926C5.39024 15.5272 5.42507 15.3499 5.42459 15.1709V9.50242C5.42418 9.14173 5.28072 8.79593 5.02567 8.54088C4.77062 8.28584 4.42482 8.14237 4.06413 8.14196ZM19.9358 8.14196C19.5751 8.14237 19.2293 8.28584 18.9743 8.54088C18.7192 8.79593 18.5758 9.14173 18.5754 9.50242V15.1709C18.5749 15.3499 18.6097 15.5272 18.6779 15.6926C18.746 15.8581 18.8462 16.0085 18.9725 16.1353C19.0989 16.262 19.249 16.3625 19.4143 16.4311C19.5796 16.4997 19.7569 16.535 19.9358 16.535C20.1148 16.535 20.292 16.4997 20.4573 16.4311C20.6226 16.3625 20.7727 16.262 20.8991 16.1353C21.0255 16.0085 21.1256 15.8581 21.1938 15.6926C21.2619 15.5272 21.2968 15.3499 21.2963 15.1709V9.50242C21.2959 9.14173 21.1524 8.79593 20.8974 8.54089C20.6423 8.28584 20.2965 8.14237 19.9358 8.14196Z" fill="currentColor"></path></svg>
                <div className='title'>Play Store</div>
              </div>
          </button>
          </a>
          <a href="https://apps.apple.com/us/app/entregakii-app-de-delivery/id1594408952" target="_blank"><button >
              <div className='subtitle'>Disponível na</div>
              <div className='info'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.94 5.19C15.318 4.75428 15.6063 4.24817 15.7882 3.70074C15.9701 3.1533 16.0421 2.57533 16 2C14.8393 2.09369 13.762 2.63956 13 3.52C12.6351 3.94198 12.3586 4.43288 12.1868 4.96364C12.015 5.49441 11.9515 6.05424 12 6.61C12.5661 6.61472 13.1258 6.4891 13.6356 6.24286C14.1454 5.99662 14.5917 5.63637 14.94 5.19ZM17.46 12.63C17.4667 11.8637 17.6685 11.1118 18.0464 10.4452C18.4244 9.77859 18.9659 9.21926 19.62 8.82C19.2072 8.22524 18.6615 7.73483 18.0262 7.38767C17.3909 7.04052 16.6835 6.84615 15.96 6.82C14.4 6.66 12.96 7.73 12.13 7.73C11.3 7.73 10.13 6.84 8.82997 6.86C7.9801 6.888 7.15199 7.13578 6.42642 7.57919C5.70085 8.02259 5.10258 8.64648 4.68997 9.39C2.92997 12.45 4.23997 17 5.99997 19.47C6.79997 20.68 7.79997 22.05 9.11997 22C10.44 21.95 10.87 21.18 12.4 21.18C13.93 21.18 14.4 22 15.7 21.97C17 21.94 17.92 20.73 18.76 19.52C19.355 18.6415 19.8198 17.6816 20.14 16.67C19.3475 16.332 18.6713 15.7693 18.195 15.0513C17.7187 14.3333 17.4632 13.4916 17.46 12.63Z" fill="currentColor"></path></svg>
                <div className='title'>App Store</div>
              </div>
          </button>
          </a>

          </div>

        </div>




    </Container>
  );
}


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 50px;
  background: #2334FF;

  svg{
    color: #2334FF;
  }

  .logo{
    width: 80%;
    max-width: 600px;
  }

  > .picture{
    width: 150px;
    height: 150px;
    background-color: #ddd;
    background-size: cover;
    border-radius: 75px;
  }

  > .title{
    font-size: 32px;
    color: #FFF;
    text-align: center;
    font-family: Whitney Bold;
    margin-top: 20px;
    max-width: 600px;
  }
  > .subtitle{
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
    max-width: 600px;
    font-family: Whitney;
  }

  .download {
    width: 100%;
    max-width: 800px;
    display: flex;
    align-items: center;
    padding: 20px 0;
  
    > .picture{
      flex: 1;
      max-width: 300px;
    }
    .app{
      width: 100%;
    }
    .buttons{
      flex: 1;
      padding: 0 50px;
    }
  }

  @media (max-width: 600px){

    & {
      padding: 20px;
    }

    .download {
    
      flex-direction: column;
      .picture{
        max-width: 40%;
      }

      .buttons{
        padding: 10px ;
        width: 100%;
      }
    }
  
  }

  a{
    width: 100%;
    max-width: 300px;

  }
  button {
 
    width: 100%;
    margin-top: 20px;
    padding: 10px;
    border-radius: 7px;
    background-color: #fff;
    box-shadow: 0 4px 14px 0  #0003;
    color: white;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    outline: none;
    cursor: pointer;
    border: none;
    font-size: inherit;
    font-family: Whitney Bold;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

  
    > .subtitle{
        color: #2334ff;
        font-size: 12px;
        font-family: Whitney;
      }
    .info {
      display: flex;
      align-items: center;
      justify-content: center;

      > .title{
        font-size: 24px;
        color: #2334ff;
        font-family: Whitney Bold;
      }
      svg{
        margin-right: 6px;
      }
     
    }
}
`;


export default HomePage;
